import orderBy from 'lodash/orderBy';

import { PlanningAssignmentBaseFragment } from 'graphql/types/generated';

/**
 * Sorts assignments into the order the planning page displays them: by week,
 * then day within the week, then creation time as a tiebreaker so assignments
 * on the same day keep a stable order. Unscheduled assignments (null week/day)
 * sort after scheduled ones because lodash orders nullish values last when
 * ascending.
 *
 * @param assignments - Assignments to sort; any shape with `week`, `day`, and
 * `created` fields.
 * @returns A new sorted array; the input array is not mutated.
 */
export function sortAssignmentsByScheduleOrder<
  T extends Pick<PlanningAssignmentBaseFragment, 'week' | 'day' | 'created'>
>(assignments: T[]): T[] {
  return orderBy(assignments, [
    (assignment) => assignment.week,
    (assignment) => assignment.day,
    (assignment) => assignment.created,
  ]);
}
